import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Overlay } from "@angular/cdk/overlay";
import { MatDialog } from '@angular/material/dialog';
import { UserService } from '../service/user.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Log } from '../util/log';
import { ActivatedRoute, Router } from '@angular/router';
import { ControlUser } from '../model/controlUser';
import { FormControl, FormGroup } from '@angular/forms';
import { AliasOwnerRel } from '../model/AliasOwnerRel';
import { dependenciesFromGlobalMetadata } from '_node_modules/@angular/compiler/src/render3/r3_factory';
import { AppComponent } from '../app.component';



@Component({
  selector: 'app-alias-detail',
  templateUrl: './alias-detail.component.html',
  styleUrls: ['./alias-detail.component.css']
})
export class AliasDetailComponent implements OnInit {

  @ViewChild('aliasloader', { static: true }) loader;

  allFeatures: number = 17;

  aliasOwnerRel: AliasOwnerRel;
  alias: ControlUser;
  aliasUid: string;
  user: any;

  features: any;

  canUserEditAlias: boolean = false;

  currentFeatures: string[] = [];

  All: string = "false";
  DeviceView: string = "false";
  DeviceEdit: string = "false";
  DeviceAction: string = "false";
  DeviceReboot: string = "false";
  DeviceViewLogs: string = "false";
  ExecutionView: string = "false";
  ExecutionEdit: string = "false";
  UserView: string = "false";
  UserEdit: string = "false";
  OperationView: string = "false";
  GroupView: string = "false";
  GroupEdit: string = "false";
  AliasView: string = "false";
  AliasEdit: string = "false";
  AcceptRequests: string = "false";
  ManageRequestTypes: string = "false";
  InsertRequests: string = "false";
  ShowInListRequests: string = "false";

  publicName: string;
  //salvo il vecchio così chiamo agg. solo quando serve
  oldPublicName: string;

  aliasPermissionsForm = new FormGroup({
    DeviceViewForm: new FormControl(''),
    DeviceEditForm: new FormControl(''),
    DeviceActionForm: new FormControl(''),
    DeviceRebootForm: new FormControl(''),
    DeviceViewLogsForm: new FormControl(''),
    ExecutionViewForm: new FormControl(''),
    ExecutionEditForm: new FormControl(''),
    UserViewForm: new FormControl(''),
    UserEditForm: new FormControl(''),
    OperationViewForm: new FormControl(''),
    GroupViewForm: new FormControl(''),
    GroupEditForm: new FormControl(''),
    AliasViewForm: new FormControl(''),
    AliasEditForm: new FormControl(''),
    AcceptRequestsForm: new FormControl(''),
    InsertRequestsForm: new FormControl(''),
    ManageRequestTypesForm: new FormControl(''),
    ShowInListRequestsForm: new FormControl('')
  });

  priorityOrder: string[] = [
    "DeviceView",
    "DeviceEdit",
    "DeviceAction",
    "DeviceReboot",
    "DeviceViewLogs",
    "ExecutionView",
    "ExecutionEdit",
    "UserView",
    "UserEdit",
    "OperationView",
    "GroupView",
    "GroupEdit",
    "AliasView",
    "AliasEdit",
    "accept-requests",
    "insert-requests",
    "show-inlist"
  ];

  constructor(
    private appComponent: AppComponent,
    private userService: UserService,
    private overlay: Overlay,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  async ngAfterViewInit() {
    this.loader.showLoading();

    this.checkPermissions();

    this.getAlias();
  }

  async checkPermissions() {
    const isAlias = await this.appComponent.isAlias();
    if (isAlias) {
      this.canUserEditAlias = await this.checkAliasPermissions("AliasEdit");
    } else {
      this.canUserEditAlias = true;
    }
  }

  async checkAliasPermissions(feature: string): Promise<boolean> {
    return this.userService.checkAliasPermissions(feature);
  }


  getAlias(): void {
    const id = this.route.snapshot.paramMap.get('id');

    this.userService.getAlias(id).subscribe(aliasOwnerRel => {

      this.aliasOwnerRel = aliasOwnerRel;
      this.alias = this.aliasOwnerRel.alias;
      this.aliasUid = aliasOwnerRel.aliasUid;

      //se manca setto email
      if (!aliasOwnerRel.publicName || aliasOwnerRel.publicName == "") {
        this.publicName = this.alias.email;
      } else {
        this.publicName = aliasOwnerRel.publicName;
      }
      this.oldPublicName = this.publicName;

      this.loader.hideLoading();
      this.parseFeatures();

      this.cdRef.detectChanges();

    }, error => {

      this.loader.hideLoading();
      this.loader.showError();
    });

    this.cdRef.detectChanges();
  }


  orderFeatures(features: string[]): string[] {
    return features.sort((a, b) => {
      const indexA = this.priorityOrder.indexOf(a);
      const indexB = this.priorityOrder.indexOf(b);

      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });
  }


  addFeature(feature: string) {
    if (feature == "accept-requests") {
      this.AcceptRequests = "true";
    } else if (feature == "insert-requests") {
      this.InsertRequests = "true";
    } else if (feature == "show-inlist") {
      this.ShowInListRequests = "true";
    } else {
      this[feature] = "true";
    }

    if (!this.currentFeatures.includes(feature)) {
      this.currentFeatures.push(feature);
    }

    Log.debug("Current features array is:");
    Log.debug(this.currentFeatures);
  }

  removeFeature(feature: string) {
    if (feature == "accept-requests") {
      this.AcceptRequests = "false";
    } else if (feature == "insert-requests") {
      this.InsertRequests = "false";
    } else if (feature == "show-inlist") {
      this.ShowInListRequests = "false";
    } else {
      this[feature] = "false";
    }

    const index = this.currentFeatures.indexOf(feature);
    if (index !== -1) {
      this.currentFeatures.splice(index, 1);
    }

    Log.debug("Current features array is:");
    Log.debug(this.currentFeatures);
  }

  parseFeatures() {

    if (this.aliasOwnerRel.availableFeature.includes("All")) {
      this.addFeature("All");
      this.addFeature("DeviceView");
      this.addFeature("DeviceEdit");
      this.addFeature("DeviceAction");
      this.addFeature("DeviceReboot");
      this.addFeature("DeviceViewLogs");
      this.addFeature("ExecutionView");
      this.addFeature("ExecutionEdit");
      this.addFeature("UserView");
      this.addFeature("UserEdit");
      this.addFeature("OperationView");
      this.addFeature("GroupView");
      this.addFeature("GroupEdit");
      this.addFeature("AliasView");
      this.addFeature("AliasEdit");
      this.addFeature("accept-requests");
      this.addFeature("insert-requests");
      this.addFeature("ManageRequestTypes");
      this.addFeature("show-inlist");

    } else {
      const featureFlags = [
        "All", "DeviceEdit", "DeviceView", "DeviceAction", "DeviceReboot", "DeviceViewLogs",
        "ExecutionView", "ExecutionEdit", "UserView", "UserEdit",
        "OperationView", "GroupView", "GroupEdit", "AliasView", "AliasEdit", "accept-requests", "insert-requests", "ManageRequestTypes", "show-inlist"
      ];

      Log.debug("Alias features:");
      Log.debug(this.aliasOwnerRel.availableFeature);

      featureFlags.forEach(feature => {

        if (this.aliasOwnerRel.availableFeature.includes(feature)) {
          this[feature] = "true";
          this.addFeature(`${feature}`);
        } else {
          this[feature] = "false";
        }
      });
    }
  }

  saveAliasFeatures(): void {

    this.loader.showLoading()

    if (this.oldPublicName != this.publicName) {

      Log.debug("Name changed");

      if (this.publicName.length < 2) {

        this.loader.hideLoading();

        let message = $localize`:@@aliasdetail_name_too_short:È necessario inserire un nome valido`;
        let header = "";

        const scrollStrategy = this.overlay.scrollStrategies.reposition();

        const confirmdialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: "350px",
          data: { message, header },
          scrollStrategy,
        });

        return;
      }


      if (this.updateAliasPublicName() == false) {
        //se non va a buon fine, non proseguire
        this.loader.hideLoading();

        let message = $localize`:@@aliasdetail_update_error:Si è verificato un errore nell'aggiornamento, riprovare più tardi`;
        let header = "";

        const scrollStrategy = this.overlay.scrollStrategies.reposition();

        const confirmdialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: "350px",
          data: { message, header },
          scrollStrategy,
        });
        return;
      }
    }

    setTimeout(() => {

      //niente permessi --> possibilità non concessa
      if (this.currentFeatures.length == 0) {
        Log.debug("No features are enabled");

        this.loader.hideLoading();

        let message = $localize`:@@aliasdetail_need_permissions:È necessario concedere almeno un permesso all'operatore`;
        let header = "";

        const scrollStrategy = this.overlay.scrollStrategies.reposition();

        const confirmdialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: "350px",
          data: { message, header },
          scrollStrategy,
        });

        return;

        // senza All sono 16 , se ci sono tutti salvare solamente "All"
      } else if (this.currentFeatures.length > this.allFeatures) {
        Log.debug("All features are enabled");

        this.aliasOwnerRel.availableFeature = ["All"];

      } else {

        Log.debug("\n\n\n\nfeatures to save:");
        Log.debug(this.currentFeatures);

        //ordino le feature
        this.currentFeatures = this.orderFeatures(this.currentFeatures);

        this.aliasOwnerRel.availableFeature = this.currentFeatures;

      }

      this.userService.postAliasFeatures(this.alias.id, this.aliasOwnerRel).subscribe(features => {

        this.features = features;
        this.loader.hideLoading();

        let message = $localize`:@@aliasdetail_save_success:Dati salvati con successo`;
        let header = "";

        const scrollStrategy = this.overlay.scrollStrategies.reposition();

        const confirmdialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: "350px",
          data: { message, header },
          scrollStrategy,
        });

        this.cdRef.detectChanges();

      }, error => {

        this.loader.hideLoading();
        this.loader.showError();
      });
      this.loader.hideLoading();


      this.cdRef.detectChanges();
    }, 1500);
  }

  updateAliasPublicName(): boolean {

    this.userService.updateAliasPublicName(this.aliasOwnerRel.id.toString(), this.publicName).subscribe(response => {
      // this.userService.updateAliasPublicName(this.alias.uid, this.publicName).subscribe(response => {

      Log.debug("updateAliasPublicName OK");

      Log.debug(response);

      return true;

    }, error => {

      Log.debug("updateAliasPublicName KO");

      Log.debug(error);

      this.loader.hideLoading();
      return false;

    });

    // il tipo boolean vuole per forza un return finale
    return true;
  }

  unlinkOwner() {


    let message = $localize`:@@aliasdetail_confirm_unlink:Desideri scollegare l'operatore?`;
    let confirmMessage = $localize`:@@aliasdetail_confirmat:Conferma`;
    let cancelMessage = $localize`:@@aliasdetail_cancel:Annulla`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { message, confirmMessage, cancelMessage },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.loader.showLoading();

        this.userService.unlinkAliasFromOwner(this.aliasUid).subscribe(data => {
          Log.debug(data);

          setTimeout(() => {
            this.loader.hideLoading();
            this.router.navigate(['aliases/']);
          }, 1500);

        });
      }
    });
  }

  //aggiungo un po' di logica al tutto

  onRadioButtonClickAll(value) {
    Log.debug("All got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("All");
      this.addFeature("DeviceView");
      this.addFeature("DeviceEdit");
      this.addFeature("DeviceAction");
      this.addFeature("DeviceReboot");
      this.addFeature("DeviceViewLogs");
      this.addFeature("ExecutionView");
      this.addFeature("ExecutionEdit");
      this.addFeature("UserView");
      this.addFeature("UserEdit");
      this.addFeature("OperationView");
      this.addFeature("GroupView");
      this.addFeature("GroupEdit");
      this.addFeature("AliasView");
      this.addFeature("AliasEdit");
      this.addFeature("accept-requests");
      this.addFeature("show-inlist");
    }
  }


  onRadioButtonClickViewDevices(value) {
    Log.debug("ViewDevices got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("DeviceView");
    } else {
      this.removeFeature("All");
      this.removeFeature("DeviceView");
      this.removeFeature("DeviceEdit");
      this.removeFeature("DeviceAction");
      this.removeFeature("DeviceReboot");
      this.removeFeature("DeviceViewLogs");
    }

  }

  onRadioButtonClickEditDevices(value) {
    Log.debug("ActionDevices got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("DeviceView");
      this.addFeature("DeviceEdit");
    } else {
      this.removeFeature("All");
      this.removeFeature("DeviceEdit");
    }
  }

  onRadioButtonClickActionDevices(value) {
    Log.debug("ActionDevices got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("DeviceView");
      this.addFeature("DeviceAction");
    } else {
      this.removeFeature("All");
      this.removeFeature("DeviceAction");
    }
  }

  onRadioButtonClickRebootDevices(value) {
    Log.debug("RebootDevices got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("DeviceView");
      this.addFeature("DeviceReboot");
    } else {
      this.removeFeature("All");
      this.removeFeature("DeviceReboot");
    }
  }

  onRadioButtonClickDevicesViewLogs(value) {
    Log.debug("DevicesViewLogs got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("DeviceView");
      this.addFeature("DeviceViewLogs");
    } else {
      this.removeFeature("All");
      this.removeFeature("DeviceViewLogs");
    }
  }

  onRadioButtonClickViewExecutions(value) {
    Log.debug("ViewExecutions got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("ExecutionView");
    } else {
      this.removeFeature("All");
      this.removeFeature("ExecutionView");
      this.removeFeature("ExecutionEdit");
    }

  }

  onRadioButtonClickEditExecutions(value) {
    Log.debug("EditExecutions got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("ExecutionView")
      this.addFeature("ExecutionEdit");
    } else {
      this.removeFeature("All");
      this.removeFeature("ExecutionEdit");
    }
  }

  onRadioButtonClickViewUsers(value) {
    Log.debug("ViewUsers got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("UserView")
    } else {
      this.removeFeature("All");
      this.removeFeature("UserView");
      this.removeFeature("UserEdit");
    }
  }

  onRadioButtonClickEditUsers(value) {
    Log.debug("EditUsers got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("UserView");
      this.addFeature("UserEdit")
    } else {
      this.removeFeature("All");
      this.removeFeature("UserEdit");
    }
  }

  onRadioButtonClickViewGroups(value) {
    Log.debug("ViewGroups got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("GroupView");
    } else {
      this.removeFeature("All");
      this.removeFeature("GroupView");
      this.removeFeature("GroupEdit");
    }
  }

  onRadioButtonClickEditGroups(value) {
    Log.debug("EditGroups got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("GroupView");
      this.addFeature("GroupEdit");
    } else {
      this.removeFeature("All");
      this.removeFeature("GroupEdit");
    }
  }

  onRadioButtonClickAliasView(value) {
    Log.debug("AliasView got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("AliasView");
    } else {
      this.removeFeature("All");
      this.removeFeature("AliasView");
      this.removeFeature("AliasEdit");
    }
  }

  onRadioButtonClickEditAlias(value) {
    Log.debug("EditAlias got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("AliasEdit");
      this.addFeature("AliasView");
    } else {
      this.removeFeature("All");
      this.removeFeature("AliasEdit");
    }
  }

  onRadioButtonClickViewOperationsLog(value) {
    Log.debug("ViewOperationsLog got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("OperationView");
    } else {
      this.removeFeature("All");
      this.removeFeature("OperationView");
    }
  }

  onRadioButtonClickViewAcceptRequests(value) {
    Log.debug("AcceptRequests got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("accept-requests");
    } else {
      this.removeFeature("All");
      this.removeFeature("accept-requests");
      this.removeFeature("insert-requests");
      this.removeFeature("show-inlist");
      this.removeFeature("ManageRequestTypes");
    }
  }


  onRadioButtonClickViewInsertRequests(value) {
    Log.debug("InsertRequests got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("accept-requests");
      this.addFeature("insert-requests");

    } else {
      this.removeFeature("All");
      this.removeFeature("insert-requests");
    }
  }

  onRadioButtonClickViewManageRequestTypes(value) {
    Log.debug("InsertRequests got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("accept-requests");
      this.addFeature("ManageRequestTypes");

    } else {
      this.removeFeature("All");
      this.removeFeature("ManageRequestTypes");
    }
  }

  onRadioButtonClickViewShowInListRequests(value) {
    Log.debug("ShowInListRequests got clicked");
    Log.debug("currentValue:" + value);
    if (value) {
      this.addFeature("accept-requests");
      this.addFeature("show-inlist");
    } else {
      this.removeFeature("All");
      this.removeFeature("show-inlist");
    }
  }
}





